import React, { FC } from 'react';
import { BucketEntry, QuicklinkOut } from '../../store/api';
import { SidebarContainer } from '../../shared/common/SidebarContainer';
import { TitleOfTheMonthItem } from './TitleOfTheMonthItem';
import { TopCharts } from './TopCharts';
import { QuickLinks } from './QuickLinks';
import { LanguageSidebar } from './LanguageSidebar';
import { Orderlist } from '../../../models/OrderList';
import { ProductMetaData } from '../../../models/Product';
import { LoanFormat } from '../../../models/LoanFormat';
import { EntryPageType } from '../../../models/EntryPage';

type Props = {
    readonly languages?: ReadonlyArray<BucketEntry>;
    readonly pageType?: EntryPageType;
    readonly loanFormatUrl?: string;
    readonly quicklinks?: ReadonlyArray<QuicklinkOut>;
    readonly titleOfMonth?: ProductMetaData;
    readonly topEaudiobooks?: ReadonlyArray<ProductMetaData>;
    readonly topEbooks?: ReadonlyArray<ProductMetaData>;
    readonly topEpress?: ReadonlyArray<ProductMetaData>;
    readonly orderLists?: ReadonlyArray<Orderlist>;
};

export const EntryPageSidebar: FC<Props> = ({
    languages,
    pageType,
    loanFormatUrl,
    quicklinks,
    titleOfMonth,
    topEaudiobooks,
    topEbooks,
    topEpress,
    orderLists
}) => {
    const onlyLanguage =
        languages &&
        languages.length > 0 &&
        (!quicklinks || quicklinks.length === 0) &&
        !titleOfMonth &&
        (!topEbooks || topEbooks.length === 0) &&
        (!topEaudiobooks || topEaudiobooks.length === 0);

    return (
        <SidebarContainer className="sidebar" width={onlyLanguage ? 240 : 300}>
            <LanguageSidebar languages={languages} loanFormatUrl={loanFormatUrl} pageType={pageType} />
            <QuickLinks quicklinks={quicklinks} />
            <TitleOfTheMonthItem product={titleOfMonth} />
            <TopCharts selectionLists={orderLists} loanFormatKey={LoanFormat.eBooks} products={topEbooks} />
            <TopCharts selectionLists={orderLists} loanFormatKey={LoanFormat.eAudiobooks} products={topEaudiobooks} />
            <TopCharts selectionLists={orderLists} loanFormatKey={LoanFormat.ePress} products={topEpress} />
        </SidebarContainer>
    );
};
